import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { DriversService } from '@services/drivers.service';
import {
  loadDrivers,
  loadDriversFailure,
  loadDriversSuccess,
} from '@store/drivers/drivers.actions';

@Injectable()
export class DriversEffects {
  private readonly actions$ = inject(Actions);
  private readonly driversService = inject(DriversService);

  getDrivers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadDrivers),
      mergeMap(() =>
        this.driversService.driversList().pipe(
          map((trailers) => loadDriversSuccess({ list: trailers })),
          catchError((error) => of(loadDriversFailure({ error: error.message }))),
        ),
      ),
    ),
  );
}
